import { Controller } from '@hotwired/stimulus';
import Sortable from 'sortablejs';

// Reorders a run's report sections. Only custom-text rows carry a drag handle, so the
// AI sections can't be picked up — but a custom text can be dropped BETWEEN them. On
// drop it PATCHes the full section order (AI + custom) to the reorder endpoint, which
// renumbers positions 1..n by that order.
export default class extends Controller {
  static values = { reorderUrl: String };

  // The controller is mounted directly on the section-list container, so it IS the
  // sortable list — no separate target needed.
  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: '.amba-sortable-handle',
      animation: 150,
      ghostClass: 'amba-sortable-ghost', // the drop-zone placeholder
      chosenClass: 'amba-sortable-chosen', // the source item while dragging
      dragClass: 'amba-sortable-drag', // the floating clone
      onEnd: () => this.persist(),
    });
  }

  disconnect() {
    this.sortable?.destroy();
  }

  async persist() {
    // Every direct child (AI + custom) carries data-id; submit the full on-screen order.
    const ids = Array.from(this.element.children)
      .map((el) => el.dataset.id)
      .filter(Boolean);
    if (ids.length === 0) return;
    try {
      await fetch(
        new URL(this.reorderUrlValue, window.location.href).toString(),
        {
          method: 'PATCH',
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
              ?.content,
            'Content-Type': 'application/json; charset=UTF-8',
            Accept: 'application/json',
          },
          body: JSON.stringify({ ids }),
        }
      );
    } catch {
      // Best-effort: the order still persists on the next full render.
    }
  }
}
